/**
 * שורת trace אחידה לטבלת Admin Price Trace (מלון / חבילה / הזמנה).
 * @param {{ n: number }} indexRef — מונה שמתעדכן במקום (למשל { n: 1 })
 * @param {object} partial — שדות לשורה; `field` משמש גם כ־step_key לוגי
 */
export function makePriceTraceStep(indexRef, partial) {
  const step = indexRef.n;
  indexRef.n += 1;
  return {
    key: partial.key ?? `t_${step}`,
    step,
    layer: partial.layer ?? "package",
    /** מזהה תוכנית לשורה: shared | unified | starter | pro | active */
    planKey: partial.planKey ?? partial.meta?.planKey ?? null,
    field: partial.field,
    rawValue: partial.rawValue ?? "—",
    normalized: partial.normalized ?? null,
    currency: partial.currency ?? "—",
    exchangeRate: partial.exchangeRate ?? "—",
    rooms: partial.rooms ?? "—",
    passengers: partial.passengers ?? "—",
    commissionPercent: partial.commissionPercent ?? "—",
    commissionAmount: partial.commissionAmount ?? "—",
    markup: partial.markup ?? "—",
    discount: partial.discount ?? "—",
    beforeRound: partial.beforeRound ?? null,
    afterRound: partial.afterRound ?? null,
    display: partial.display ?? null,
    anomaly: partial.anomaly ?? null,
    notes: partial.notes ?? "",
    sourceFile: partial.sourceFile ?? "",
    sourceFunction: partial.sourceFunction ?? "",
    priceChanged: partial.priceChanged ?? false,
    anomalyFlag: partial.anomalyFlag ?? false,
    meta: partial.meta ?? null,
    fx_source: partial.fx_source ?? "",
    fx_rate: partial.fx_rate ?? "",
    commission_plan: partial.commission_plan ?? "",
    commission_type: partial.commission_type ?? "",
    commission_value: partial.commission_value ?? "",
    is_applied: partial.is_applied ?? "",
  };
}
